<template>
  <section class="page-container">
    <div class="header">
      <div class="flex">
        <div class="company_logo">
          <img :src="getOptionData('companySmallIcon', options.company_id).logo">
        </div>
        <div class="product_logo">
          <font-awesome-icon
            :icon="getOptionName('iconOptions', options.class_id)" />
        </div>
        <div
          v-if="insurerPlanList.length"
          class="plan_name">{{insurerPlanList[insurerListActive].plan_list[options.plan_id]}}</div>
      </div>
      <!-- <div class="time">
        <span class="update">Updated</span>01-01-2021 12:34:56
      </div> -->
      <div class="tabs">
        <el-tabs
          v-model="activeTab"
          @tab-click="tabClick">
          <el-tab-pane
            v-for="(tab, index) in tabList"
            :key="index"
            :name="String(tab.name)"
          >
            <span slot="label">
              <font-awesome-icon
                class="icon"
                :icon="tab.icon"></font-awesome-icon>
              {{tab.label}}
            </span>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="body-content">
      <router-view></router-view>
    </div>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import {mapState, mapActions} from 'vuex'
import {getInsurerPlanList} from '@/api/account'

export default {
  name: 'InsurerPlanDetail',
  mixins: [MixinOptions],
  data () {
    return {
      activeTab: 'policy',
      tabList: [
        {
          label: 'Policies',
          name: 'policy',
          icon: 'file-powerpoint'
        },
        {
          label: 'Quotes',
          name: 'quote',
          icon: 'dollar-sign'
        },
        {
          label: 'Documents',
          name: 'document',
          icon: 'file'
        },
        {
          label: 'Commission',
          name: 'commission',
          icon: 'percent'
        },
        {
          label: 'Claim Method',
          name: 'claim-method',
          icon: 'hand-holding-dollar'
        },
      ]
    }
  },
  computed:{
    ...mapState('account', ['insurerPlanList','insurerListActive']),
    options(){
      return this.$route.query || null
    }
  },
  watch:{
    $route:{
      immediate: true,
      deep: true,
      handler(val){
        let name = val.name
        let tab = 'policy'
        switch(name){
          case 'insurerAccountsPlanDetailPolicy':
            tab = 'policy'
            break
          case 'insurerAccountsPlanDetailQuote':
            tab = 'quote'
            break
          case 'insurerAccountsPlanDetailDocument':
            tab = 'document'
            break
          case 'insurerAccountsPlanDetailCommission':
            tab = 'commission'
            break
          case 'insurerAccountsPlanDetailClaimMethod':
            name = 'claim-method'
            break
        }
        this.activeTab = tab
      }
    },
    insurerPlanList:{
      immediate: true,
      deep: true,
      handler(val){
        if(val.length == 0){
          this.network().getInsurerPlanList()
        }
      }
    }
  },
  methods: {
    ...mapActions('account', ['setinsurerListActive','setInsurerPlanList']),
    tabClick(){
      let name = ''
      switch(this.activeTab){
        case 'policy':
          name = 'insurerAccountsPlanDetailPolicy'
          break
        case 'quote':
          name = 'insurerAccountsPlanDetailQuote'
          break
        case 'document':
          name = 'insurerAccountsPlanDetailDocument'
          break
        case 'commission':
          name = 'insurerAccountsPlanDetailCommission'
          break
        case 'claim-method':
          name = 'insurerAccountsPlanDetailClaimMethod'
          break
      }
      this.$router.push({
        name,
        query:{
          ...this.options
        }
      })
    },
    network(){
      return{
        getInsurerPlanList: async () => {
          const {data} = await getInsurerPlanList({
            company_id: this.options.company_id
          })
          this.setInsurerPlanList(data)
          data.some((item, index) => {
            if(item.id == this.options.class_id){
              this.setinsurerListActive(index)
            }
          })
        }
      }
    }
  },
}
</script>
<style lang='scss' scoped>
.page-container{
  background: #FFF;
  margin: -20px;
  min-height: 100vh;
  .body-content{
    padding: 0 70px;
  }
}
.header{
  padding: 20px 70px;
  .company_logo, .product_logo{
    width: 22px;
    height: 22px;
    background: #E1E4E8;
    border-radius: 5px;
    margin-right: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    img{
      width: 100%;
    }
  }
  .plan_name{
    margin-left: 5px;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #24292E;
  }
  .time{
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #24292E;
    margin: 10px 0;
    .update{
      font-weight: 600;
      color: #586069;
      margin-right: 8px;
    }
  }
  .tabs{
    margin-top: 10px;
    /deep/.el-tabs{
      .el-tabs__item{
        font-weight: 400;
        font-size: 14px;
        color: #24292E;
        .icon{
          font-weight: 900;
          font-size: 14px;
          color: #959DA5;
          margin-right: 10px;
        }
        &.is-active{
          font-weight: 600;
          color: #24292E;
          .icon{
            color: #24292E;
          }
        }
      }
      .el-tabs__item>span{
        padding: 14px 16px;
      }
      .el-tabs__active-bar{
        background-color: #F9826C;;
      }
    }
  }
}
</style>
